import * as form from '../form';

export const citizenshipStatus = (data = {}) => ({
  CitizenshipStatus: form.radio(data.CitizenshipStatus),
  CitizenshipStatusComments: form.textarea(data.CitizenshipStatusComments),
  AlienRegistrationComments: form.textarea(data.AlienRegistrationComments),
  AlienRegistrationNumberComments: form.textarea(data.AlienRegistrationNumberComments),
  DerivedComments: form.textarea(data.DerivedComments),
  MilitaryBaseComments: form.textarea(data.MilitaryBaseComments),
  ProofOfUSCitizenshipComments: form.textarea(data.ProofOfUSCitizenshipComments),
  CertificateComments: form.textarea(data.CertificateComments),
  NaturalizationComments: form.textarea(data.NaturalizationComments),
  EntryDateExplanation: form.textarea(data.EntryDateExplanation),
  EntryLocationExplanation: form.textarea(data.EntryLocationExplanation),
  AlienRegistrationNumberExplanation: form.textarea(data.AlienRegistrationNumberExplanation),
  AbroadDocumentation: form.radio(data.AbroadDocumentation),
  Explanation: form.textarea(data.Explanation),
  DocumentNumber: form.text(data.DocumentNumber),
  DocumentNumberNotApplicable: form.notapplicable(data.DocumentNumberNotApplicable), // PVQ Only
  DocumentNumberNotApplicableExplanation: form.textarea(data.DocumentNumberNotApplicableExplanation), // PVQ Only
  DocumentIssued: form.datecontrol(data.DocumentIssued),
  DocumentName: form.name(data.DocumentName),
  DocumentExpiration: form.datecontrol(data.DocumentExpiration),
  DocumentExpirationNotApplicable: form.notapplicable(data.DocumentExpirationNotApplicable), // PVQ Only
  DocumentType: form.radio(data.DocumentType),
  DocumentTitle: form.text(data.DocumentTitle), // PVQ Only
  PlaceIssued: form.location(data.PlaceIssued),
  IssuedInUS: form.branch(data.IssuedInUS), // PVQ Only
  CertificateNumber: form.text(data.CertificateNumber),
  CertificateIssued: form.datecontrol(data.CertificateIssued),
  CertificateName: form.name(data.CertificateName),
  CertificateMotherMaidenName: form.name(data.CertificateMotherMaidenName),
  CertificateCourtName: form.text(data.CertificateCourtName),
  CertificateCourtAddress: form.location(data.CertificateCourtAddress),
  BornOnMilitaryInstallation: form.branch(data.BornOnMilitaryInstallation),
  MilitaryBase: form.text(data.MilitaryBase),
  EntryDate: form.datecontrol(data.EntryDate),
  EntryDateNotApplicable: form.notapplicable(data.EntryDateNotApplicable),
  EntryLocation: form.location(data.EntryLocation),
  EntryLocationNotApplicable: form.notapplicable(data.EntryLocationNotApplicable),
  PriorCitizenship: form.country(data.PriorCitizenship),
  HasAlienRegistration: form.branch(data.HasAlienRegistration),
  AlienRegistrationNumber: form.text(data.AlienRegistrationNumber),
  AlienRegistrationNumberNotApplicable: form.notapplicable(data.AlienRegistrationNumberNotApplicable),
  AlienRegistrationExpiration: form.datecontrol(data.AlienRegistrationExpiration),
  AlienRegistrationCardNumber: form.text(data.AlienRegistrationCardNumber), // PVQ Only
  Basis: form.radio(data.Basis),
  PermanentResidentCardNumber: form.text(data.PermanentResidentCardNumber),
  CitizenshipCertificateCardNumberNotApplicable: form.notapplicable(data.CitizenshipCertificateCardNumberNotApplicable), // PVQ Only
  ResidenceStatus: form.text(data.ResidenceStatus),
  ResidenceStatusExplanation: form.textarea(data.ResidenceStatusExplanation), // PVQ Only
  MaidenName: form.text(data.MaidenName),
  Form240Date: form.datecontrol(data.Form240Date),
  Form240DateExplanation: form.textarea(data.Form240DateExplanation),
  BornOnUSMilitaryInstallation: form.branch(data.BornOnUSMilitaryInstallation), // PVQ Only
  BornOnUSMilitaryInstallationName: form.text(data.BornOnUSMilitaryInstallationName), // PVQ Only
  IsResidentOfUnitedStates: form.branch(data.IsResidentOfUnitedStates), // PVQ Only
});
